
import { defineComponent, ref, watch } from "vue";
import CustomRouterLink from "@/components/CustomRouterLink.vue";
import MobileMenu from "@/layout/MobileMenu.vue";

export default defineComponent({
  name: "the-header",
  components: {
    CustomRouterLink,
    MobileMenu,
  },
  setup() {
    const isMenuOpen = ref(false);
    watch(
      () => isMenuOpen.value,
      (val) => {
        document.body.style.overflow = val ? "hidden" : "auto";
      }
    );
    return { isMenuOpen };
  },
});
